export const mockSegments = [
  {
    id: 1,
    name: "VIP Scanners",
    description: "Customers who scan 10+ times per month",
    type: "behavioral",
    criteria: {
      scanFrequency: { min: 10, period: "month" },
      regions: ["all"]
    },
    estimatedSize: 847,
    color: "#173131",
    createdAt: "2024-12-01T10:00:00Z"
  },
  {
    id: 2,
    name: "US Premium Collectors",
    description: "US customers who scan premium wines ($100+)",
    type: "geographic_behavioral",
    criteria: {
      regions: ["United States"],
      productPriceRange: { min: 100 },
      scanHistory: { active: true }
    },
    estimatedSize: 1234,
    color: "#A59063",
    createdAt: "2024-11-15T14:30:00Z"
  },
  {
    id: 3,
    name: "European Wine Enthusiasts",
    description: "EU customers with regular scanning activity",
    type: "geographic",
    criteria: {
      regions: ["United Kingdom", "France", "Germany", "Italy"],
      scanFrequency: { min: 3, period: "month" }
    },
    estimatedSize: 2156,
    color: "#5F011E",
    createdAt: "2024-10-20T09:15:00Z"
  },
  {
    id: 4,
    name: "First-Time Scanners",
    description: "New customers who scanned for the first time in last 30 days",
    type: "behavioral",
    criteria: {
      firstScanDate: { within: 30, unit: "days" },
      totalScans: { max: 3 }
    },
    estimatedSize: 456,
    color: "#C4AB74",
    createdAt: "2025-01-01T11:20:00Z"
  },
  {
    id: 5,
    name: "Bordeaux Lovers",
    description: "Customers who frequently scan Bordeaux wines",
    type: "product_preference",
    criteria: {
      productCategories: ["Bordeaux", "French Wine"],
      scanFrequency: { min: 5, period: "month" }
    },
    estimatedSize: 678,
    color: "#EDDDD3",
    createdAt: "2024-09-10T16:45:00Z"
  },
  {
    id: 6,
    name: "Lapsed Customers",
    description: "Previously active customers who haven't scanned in 60+ days",
    type: "behavioral",
    criteria: {
      lastScanDate: { moreThan: 60, unit: "days" },
      totalScans: { min: 5 }
    },
    estimatedSize: 234,
    color: "#9E9E9E",
    createdAt: "2024-08-05T12:30:00Z"
  }
];

export const segmentTypes = [
  { value: "geographic", label: "Geographic", description: "Based on location data from scans" },
  { value: "behavioral", label: "Behavioral", description: "Based on scanning patterns and frequency" },
  { value: "product_preference", label: "Product Preference", description: "Based on wine types and categories scanned" },
  { value: "engagement", label: "Engagement Level", description: "Based on app usage and interaction" },
  { value: "custom", label: "Custom", description: "Create your own criteria combination" }
];

export const segmentCriteria = {
  geographic: {
    regions: {
      label: "Regions",
      type: "multiselect",
      options: ["United States", "United Kingdom", "France", "Germany", "Australia", "Canada", "Italy", "Global"]
    },
    cities: {
      label: "Cities",
      type: "multiselect",
      options: ["New York", "London", "Paris", "Berlin", "Sydney", "Toronto", "Rome"]
    }
  },
  behavioral: {
    scanFrequency: {
      label: "Scan Frequency",
      type: "range",
      options: { min: 0, max: 100, period: ["day", "week", "month", "year"] }
    },
    lastScanDate: {
      label: "Last Scan",
      type: "date_range",
      options: { unit: ["days", "weeks", "months"], direction: ["within", "moreThan"] }
    },
    totalScans: {
      label: "Total Scans",
      type: "range",
      options: { min: 0, max: 1000 }
    }
  },
  product_preference: {
    productCategories: {
      label: "Wine Categories",
      type: "multiselect",
      options: ["Bordeaux", "Burgundy", "Champagne", "Italian Wine", "Spanish Wine", "New World", "Vintage", "Premium"]
    },
    priceRange: {
      label: "Price Range",
      type: "range",
      options: { min: 0, max: 1000, currency: "USD" }
    }
  },
  engagement: {
    appUsage: {
      label: "App Usage",
      type: "select",
      options: ["High", "Medium", "Low", "Inactive"]
    },
    verificationRate: {
      label: "Verification Success Rate",
      type: "range",
      options: { min: 0, max: 100, unit: "%" }
    }
  }
};